import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { BsYoutube } from 'react-icons/bs'
import './footer.css';

const Footer = () => {
  
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
  
  return (
    <footer>
      <a href="#home" className="footer__logo">Anele Sokwane</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
      <a href="https://www.linkedin.com/in/anele-sokwane/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/KingAJ19" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://www.youtube.com/@KingAJ19" target="_blank" rel="noreferrer" ><BsYoutube /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; AS {getYear()}. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
